import api from "@/api.js";

export default {
  state: {
    siteData: {},
    fullLoading: false,
    dateRange: [],
    navigationDrawer: true,
    aGGridActionMenu: false,
    selectedRowData: {},
    appID: {},
    siteSettings: {}
  },
  mutations: {
    setSiteData(state, payload) {
      state.siteData = payload;
    },
    setFullLoader(state, loading) {
      state.fullLoading = loading;
    },
    setDateRange(state, date) {
      state.dateRange = date;
    },
    setNavigationDrawer(state, drawer) {
      state.navigationDrawer = drawer;
    },
    setAGGridActionMenu(state, payload) {
      state.aGGridActionMenu = payload;
    },
    setSelectedRowData(state, rowData) {
      state.selectedRowData = rowData;
    },
    setAppID(state, id) {
      state.appID = id;
    }
  },
  actions: {
    async loadSiteData({ commit }) {
      let siteData = await api.get("applications/siteData");
      commit("setSiteData", siteData.data);
      document.title = siteData.data.name;
    },
    setFullLoaderState({ commit }, loading) {
      commit("setFullLoader", loading);
    },
    async loadDateRange({ commit }, payload) {
      commit("setDateRange", payload);
    },
    async loadDefaultDateRange({ commit }) {
      let d = new Date();
      let lw = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
      let dd = "";
      let dm = "";
      let lwd = "";
      let lwm = "";
      if (d.getDate() < 10) {
        dd = "0";
      }
      if (d.getMonth() < 10) {
        dm = "0";
      }
      if (lw.getDate() < 10) {
        lwd = "0";
      }
      if (lw.getMonth() < 10) {
        lwm = "0";
      }
      commit("setDateRange", [
        `${d.getFullYear()}-${dm}${d.getMonth() + 1}-${dd}${d.getDate()}`,
        `${lw.getFullYear()}-${lwm}${lw.getMonth() + 1}-${lwd}${lw.getDate()}`
      ]);
    },
    async setNavigationDrawerState({ commit }, payload) {
      commit("setNavigationDrawer", payload);
    },
    async setAGGridActionMenuState({ commit, state }, payload) {
      commit("setAGGridActionMenu", !state.aGGridActionMenu);
      commit("setSelectedRowData", payload);
    },
    async setSelectedRowData({ commit }, payload) {
      commit("setSelectedRowData", payload);
    },
    async getAppID({ commit }) {
      if (
        window.location.host == "flexicomms.firebaseapp.com" ||
        window.location.host == "localhost:8080" ||
        window.location.host == "192.168.178.21:8080"
      ) {
        commit("setAppID", 0);
      }
    },
    randomString({ commit }, payload) {
      var mask = "";
      if (payload.chars.indexOf("a") > -1) mask += "abcdefghijklmnopqrstuvwxyz";
      if (payload.chars.indexOf("A") > -1) mask += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      if (payload.chars.indexOf("#") > -1) mask += "0123456789";
      if (payload.chars.indexOf("!") > -1)
        mask += "~`!@#$%^&*()_+-={}[]:\";'<>?,./|\\";
      var result = "";
      for (var i = payload.len; i > 0; --i)
        result += mask[Math.floor(Math.random() * mask.length)];
      return result;
    }
  },
  getters: {
    siteData(state) {
      return state.siteData;
    },
    dateRange(state) {
      return state.dateRange;
    },
    fullLoading(state) {
      return state.fullLoading;
    },
    navigationDrawer(state) {
      return state.navigationDrawer;
    },
    aGGridActionMenu(state) {
      return state.aGGridActionMenu;
    },
    selectedRowData(state) {
      return state.selectedRowData;
    }
  }
};
